import React, { useEffect, useRef, useState } from "react";
import ControlledSelectElement from "../../components/elements/ControlledSelectElement2";
import { useMutation } from "@tanstack/react-query";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import {
  CORE_CITY,
  CORE_CITY_NO_ID,
  CORE_PROVINCE,
  COMMON_STORE_GROUPS,
  STORE_STORES,
} from "../../api/apiClient";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import customZ from "../../utils/setZodCustomMessages";
import { notEmptyField } from "../../utils/customSchemas";

import {
  PRODUCT_CLASSIFY_TYPE,
  STORE_PRODUCT_GROUP,
} from "../../api/apiClient";
import AnimatedSingleSelect from "../../components/elements/AnimatedSingleSelect";
import { IFormData } from "../../pages/seller-stepper/SellerStepper";
import { clickOutside } from "../../utils/clickOutside";
import { ReactComponent as Adjustments } from "../../iconColor/adjustments-horizontal.svg";

//

const step2Schema = customZ.object({
  name: notEmptyField,
});
interface FilterShopsProps {
  inputQuery: any;
  setInputQuery: any;
  searchQuery: any;
  setSearchQuery: any;
  productgroup_uuid: any;
  setProductgroup_uuid: any;
  provinceId: any;
  setProvinceId: any;
  store_group: any;
  setStore_group: any;
  city_Id: any;
  setCity_Id: any;
}
const FilterShops: React.FC<FilterShopsProps> = ({
  inputQuery,
  setInputQuery,
  searchQuery,
  setSearchQuery,
  productgroup_uuid,
  setProductgroup_uuid,
  store_group,
  setStore_group,
  provinceId,
  setProvinceId,
  city_Id,
  setCity_Id,
}) => {
  const {
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step2Schema)(data, context, options);
    },
  });
  const [showFilter, setShowFilter] = useState<boolean>(false);

  const access_token = localStorage.getItem("access_token");
  const [sellerForm2Info, setSellerForm2Info] = useState<any>(undefined);
  const [filledItems, setFilledItems] = useState<any>(false);
  const [isImageDocLoading, setIsImageDocLoading] = useState(true);
  const [isImageStoreLoading, setIsImageStoreLoading] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(true);
  const [city, setCity] = useState([
    { name: "", id: 1, city: 1, prefix_number: "021" },
  ]);
  const [province, setProvince] = useState([{ name: "", id: 1 }]);
  const [prefixNum, setPrefixNum] = useState<any>(undefined);
  const [prName, setPRName] = useState<any>(undefined);
  const [ciName, setCIName] = useState<any>(undefined);
  const [receivedValue, setReceivedValue] = useState("");
  const [cityId, setCityId] = useState<any>("");
  const [productJson, setProductJson] = useState<any>(undefined);
  // const applicantPhoneNumber = localStorage.getItem("applicant_phone_number");
  // const store_uid = localStorage.getItem("selected_store_uid");
  const [mergedProductJson, setMergedProductJson] = useState<any>(undefined);
  const [productGroupList, setProductGroupList] = useState([
    { product_group_uid: "در حال بارگذاری", name: "در حال بارگذاری" },
  ]);
  const [productTypeList, setProductTypeList] = useState([
    { product_type_uid: "در حال بارگذاری", name: "در حال بارگذاری" },
  ]);
  // const [brandList, setBrandList] = useState([
  //   { brand_uid: "در حال بارگذاری", name: "در حال بارگذاری" },
  // ]);
  // const [productList, setProductList] = useState([
  //   { product_uid: "در حال بارگذاری", name: "در حال بارگذاری" },
  // ]);
  const firstLoanRef = useRef<HTMLDivElement>(null);
  const [brand_uid, setBrand_uid] = useState<any>(undefined);
  const [product_type_uid, setProduct_type_uid] = useState<any>(undefined);
  const [product_uid, setProduct_uid] = useState<any>(undefined);
  const [product_group_uid, setProduct_group_uid] = useState<any>(undefined);
  const [storeGroupList, setStoreGroupList] = useState<any>(undefined)
  const [spacialGroup, setSpacialGroup] = useState<any>(undefined);

  useEffect(() => {
    if (receivedValue) {
      setValue("address", receivedValue);
    }
  }, [receivedValue]);

  useEffect(() => {
    if (
      city[
      city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
      ] !== undefined
    ) {
      setPrefixNum(
        city[
        city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
        ]["prefix_number"]
      );
    } else {
      setPrefixNum(null);
    }
  }, [getValues("city")]);

  const getProvince = async () =>
    axiosPrivate
      .get(
        CORE_PROVINCE,

        {
          withCredentials: true,
        }
      )
      .then((res) => res.data.data.result);

  const provinceMutation = useMutation({
    mutationFn: () => getProvince(),
    onSuccess(data, variables, context) {
      setProvince(data);
    },
  });

  const getAllCity = async () =>
    axiosPrivate
      .get(CORE_CITY_NO_ID, {
        withCredentials: true,
      })
      .then((res) => res.data.data.result);

  const findProvinceMutation = useMutation({
    mutationFn: () => getAllCity(),
    onSuccess(data: any, variables, context) {
      let res = data;

      var city_name =
        res[res.findIndex((obj: any) => obj["id"] === cityId)]["name"];

      setPrefixNum(
        res[res.findIndex((obj: any) => obj["id"] === cityId)]["prefix_number"]
      );

      var province_name =
        province[
        province.findIndex(
          (o: any) =>
            o["id"] ===
            res[res.findIndex((obj: any) => obj["id"] === cityId)][
            "province_id"
            ]
        )
        ]["name"];
      setPRName(province_name);
      setCIName(city_name);
    },
  });

  useEffect(() => {
    if (sellerForm2Info) {
      setCityId(sellerForm2Info.city);
      findProvinceMutation.mutate();
    }
  }, [sellerForm2Info, provinceMutation.isSuccess]);

  const getSellerForm2Info = async () => {
    const data: { [key: string]: string | number | undefined } = {};
    if (city_Id || provinceId || store_group) {
      data.city_id = city_Id;
      data.province_id = provinceId;
      data.store_group = store_group.value;
    }
    // setIsLoadingContents(true);
    setIsSubmiting(true);
    try {
      const response = await axiosPrivate.get(STORE_STORES, {
        withCredentials: true,
        params: data,
      });

      setSellerForm2Info(response?.data.data);
      if (response?.status >= 200 && response?.status < 300) {
        setIsImageDocLoading(true);
        setIsImageStoreLoading(true);

        // setIsLoadingContents(false);
        setFilledItems(true);
        setIsSubmiting(false);
      } else {
        // setIsLoadingContents(false);
      }
    } catch (error) {
      setIsImageDocLoading(false);
      setIsImageStoreLoading(false);

      // setIsLoadingContents(false);
      setIsSubmiting(false);
    } finally {
      // setIsLoadingContents(false);
    }
  };

  useEffect(() => {
    getSellerForm2Info();
    findProvinceMutation.mutate();
    provinceMutation.mutate();
  }, []);

  useEffect(() => {
    getSellerForm2Info();
  }, [store_group])

  useEffect(() => {
    setValue("name", sellerForm2Info?.name);
    setValue("telephone_number", sellerForm2Info?.telephone_number);
    setValue(
      "phone_number_sec",
      sellerForm2Info?.phone_number_sec ? sellerForm2Info?.phone_number_sec : ""
    );
    setValue("postal_code", sellerForm2Info?.postal_code);
    setValue(
      "address",
      receivedValue ? receivedValue : sellerForm2Info?.address
    );
    setValue("store_doc_img", sellerForm2Info?.store_doc_img);
    setValue("store_image", sellerForm2Info?.store_image);
    setValue("city", String(sellerForm2Info?.city));
    setValue("logo", sellerForm2Info?.logo_uid);
  }, [setValue, sellerForm2Info]);

  useEffect(() => {
    const textAreaValue = getValues("address");

    if (receivedValue && textAreaValue === receivedValue) {
      setValue("address", receivedValue);
    }
  }, [receivedValue, getValues]);

  function cityAdder(data: any) {
    for (let i = 0; i < data.length; i++) {
      data[i]["city"] = data[i]["id"];
    }
    return data;
  }
  const getCityTest = (id: number) =>
    axiosPrivate
      .get(
        CORE_CITY(id),

        {
          withCredentials: true,

          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      )
      .then((res) => cityAdder(res.data.data.result));
  const cityMutate = useMutation({
    mutationFn: (id: any) => getCityTest(provinceId),
    onSuccess(data, variables, context) {
      setCity(data);
    },
  });

  const getStoreGroups = () =>
    axiosPrivate
      .get(
        COMMON_STORE_GROUPS,

        {
          withCredentials: true,

          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      )
      .then((res) => res.data.data.result);
  const StoreGroupsMutate = useMutation({
    mutationFn: () => getStoreGroups(),
    onSuccess(data, variables, context) {
      setStoreGroupList(data);
    },
  });

  useEffect(() => {
    StoreGroupsMutate.mutate()
  }, [])

  useEffect(() => {
    getValues("id") !== undefined && watch("id") !== "undefined" && cityMutate.mutate(watch("id"));
  }, [watch("id"), getValues("id")]);

  const getProductList = () =>
    axiosPrivate
      .get(STORE_PRODUCT_GROUP)

      .then((res) => res?.data?.data?.result);

  const getProductTypes = (product_group_uid: string) =>
    axiosPrivate
      .get(PRODUCT_CLASSIFY_TYPE(product_group_uid), {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        globalErrorHandler: false,
      } as CustomAxiosRequestConfig)
      .then((res) => res?.data?.data?.result);

  const getStoreProductLists = useMutation({
    mutationFn: () => getProductList(),
    onSuccess(data, variables, context) {
      setProductGroupList((prev: any) => data);
    },
    onError() {
      console.error("error in fetching data (productGroup)");
    },
  });

  useEffect(() => {
    getStoreProductLists.mutate();
  }, []);

  const productTypeListMutation = useMutation({
    mutationFn: (product_group_uid: string) =>
      getProductTypes(product_group_uid),
    onSuccess(data, variables, context) {
      setProductTypeList(data);
    },
    onError() {
      console.error("error in fetching data (productttype)");
    },
  });

  useEffect(() => {
    if (watch("product_group_uid") !== undefined) {
      productTypeListMutation.mutate(watch("product_group_uid"));
    }
  }, [watch("product_group_uid")]);

  useEffect(() => {
    merger(productJson);

    if (firstLoanRef.current) {
      firstLoanRef.current.scrollIntoView({ behavior: "smooth" });
      const element = document.getElementById("content");
      setTimeout(() => {
        element && element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [productJson]);

  function merger(json: any) {
    if (json !== undefined) {
      var result = [];
      var passed: string | any[] = [];
      for (let i = 0; i < json.length; i++) {
        var product_id = json[i].product;
        var found = false;
        if (!passed.includes(product_id)) {
          passed.push(product_id);
          for (let j = i + 1; j < json.length; j++) {
            var exp_product = json[j].product;
            if (product_id === exp_product) {
              found = true;
              result.push({
                product: exp_product,
                price: json[j].price,
                series: [json[i].series, json[j].series],
                description: json[j].description,
              });
            }
          }
          if (found === false) {
            result.push({
              product: json[i].product,
              price: json[i].price,
              series: [json[i].series],
              description: json[i].description,
            });
          }
          found = false;
        }
      }
      setMergedProductJson(result);
    } else {
      setMergedProductJson(undefined);
    }
  }

  const handleStoreGroup = (options: any) => {
    if (options !== null) {
      setStore_group(options)
    } else {
      setStore_group(undefined)
    }
  }

  const handleOptionChange = (options: any, uid: any) => {
    if (uid === "product_group_uid") {
      setProduct_group_uid(options);
      setBrand_uid(null);
      setProduct_type_uid(null);
      setProduct_uid(null);
    } else if (uid === "product_type_uid") {
      setProduct_type_uid(options);
      setBrand_uid(null);
      setProduct_uid(null);
    } else if (uid === "brand_uid") {
      setBrand_uid(options);
      setProduct_uid(null);
    } else if (uid === "product_uid") {
      setProduct_uid(options);
    }
    setProductgroup_uuid(options.map((option: any, idx: any) => option.value));
  };
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    clickOutside(selectRef, "FilterBoxes", setShowFilter);
  }, []);
  return (
    <div ref={selectRef} className="relative z-20">
      <div
        onClick={() => {
          setShowFilter(!showFilter);
        }}
        className="flex h-[36px] pt-2 pb-2 pr-4 pl-4 justify-center items-center gap-2 rounded-lg border border-solid border-gray-200 hover:bg-gray-50 cursor-pointer"
      >
        <Adjustments />
        <p className="flex text-right text-gray-900 whitespace-nowrap text-BodyText/12/Medium">
          فیلتر ها
        </p>
      </div>
      {showFilter && (
        <div
          id="FilterBoxes"
          className="absolute w-[250px] top-full left-0 flex-col p-4 items-start gap-4 rounded-lg bg-white shadow-surround border border-gray-200"
        >
          <div className="flex flex-col w-full gap-2">
            <div className="flex justify-between items-center w-full">
              <p className="text-center text-gray-700 text-Title/16/Bold">
                فیلتر‌ها:
              </p>
              <p
                onClick={() => {
                  setProvinceId("");
                  setCity_Id("");
                  setInputQuery("");
                  setSearchQuery("");
                  setProductgroup_uuid([]);
                  setProduct_group_uid(null);
                  setProduct_type_uid(null);
                  setBrand_uid(null);
                  setProduct_uid(null);
                  setShowFilter(!showFilter);
                  setStore_group(undefined);
                }}
                className="text-center text-red-600 text-BodyText/12/Regular cursor-pointer"
              >
                حذف همه
              </p>
            </div>
            <div className="w-full h-[1px] bg-gray-200"></div>

            <ControlledSelectElement
              Reset={watch("id")}
              label="استان"
              isLoading={
                sellerForm2Info
                  ? findProvinceMutation?.isPending
                  : provinceMutation?.isPending
              }
              options={province}
              getOptionLabel={(item) => item?.name}
              control={control}
              name="id"
              errors={errors?.id}
              showNonOption
              defaultSelectValue={"انتخاب کنید"}
              mode="multiSelect"
              onChange={(e) => {
                setProvinceId(e?.id);
                setInputQuery("");
                setCity_Id("");
                setSearchQuery("");
              }}
              size="verysmall"
            />

            <ControlledSelectElement
              APIgetValue={sellerForm2Info ? ciName : undefined}
              disabled={watch("id") === undefined}
              isLoading={cityMutate.isPending}
              label="شهر"
              options={city}
              getOptionLabel={(item) => item?.name}
              control={control}
              name="city"
              errors={errors?.city}
              showNonOption
              defaultSelectValue={"انتخاب کنید"}
              mode="multiSelect"
              onChange={(e) => {
                setCity_Id(e?.id);
              }}
              size="verysmall"
            />

            <AnimatedSingleSelect
              placeHolder={"انتخاب کنید"}
              Name="name"
              clearAble
              isLoading={StoreGroupsMutate.isPending}
              topLabel="گروه خاص"
              value={store_group}
              valueName="code_name"
              options={storeGroupList}
              onOptionChange={(e: any) =>
                handleStoreGroup(e)
              }
            />

            <AnimatedSingleSelect
              placeHolder={"گروه کالای خود را انتخاب کنید"}
              Name="name"
              isLoading={getStoreProductLists.isPending}
              topLabel="گروه کالا"
              value={product_group_uid}
              valueName="product_group_uid"
              options={productGroupList}
              onOptionChange={(e: any) =>
                handleOptionChange(e, "product_group_uid")
              }
              isMulti={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterShops;
